import React from 'react';
import ReactDOM from 'react-dom';
import './index.css'; // Global styles
import '../src/style/main.css'; // Tailwind CSS
import App from './App';
import { AuthContextProvider } from './context/AuthContext.js';

ReactDOM.render(
  <AuthContextProvider>
    <div className="bg-dafauna-background min-h-screen">
      <App />
    </div>
  </AuthContextProvider>,
  document.getElementById('root')
);